export enum Paths {
  ResidenceCountries = '/app-data/residence-countries',
  SignUp = '/authentication/sign-up',
  SignIn = '/authentication/sign-in',
  CheckLoginStatus = '/authentication/login-status',
  SignInWithSessionId = '/authentication/sign-in-with-session-id',
  Logout = '/authentication/logout',
  SendEmailVerificationRequest = '/user/email-verification-request',
  SumsubVerificationToken = '/sumsub/user',
  GetUser = '/user',
  AccessToken = '/access_token',
  GetProducts = '/products',
  GetProductDetails = '/products/product-details',
  GetTab = '/products/tab',
  SendPasswordResetRequest = '/authentication/password-reset-request',
  InvestmentIntent = '/investments/investment-intent-transaction',
  MinimumInvestmentAmount = '/investments/min-investment-amount',
  GetEmbeddedContract = '/investments/embedded-contract',
  GetExternalContract = '/contract/external',
  ProductNotificationRequest = 'product-notification',
  UserPortfolio = '/user-portfolio/portfolio',
  Questionnaire = '/questionnaire/template',
  CompletedQuestionnaire = '/questionnaire/completed',
  UserTransactions = '/user-portfolio/transactions',
  UpdatePassword = '/authentication/update-password',
  MarketingPreferences = '/user/market-preferences',
  UserAvatar = '/avatar',
  UserDocuments = '/user/documents',
  Company = '/company',
  CompanySignatory = '/company-signatory',
  CompanyVerificationRequest = '/sumsub/company',
  UltimateBeneficialOwner = '/ubo',
  NomineeAgent = '/nominee-agent',
  NomineeAgentEmailVerification = '/nominee-agent/email-verification',
  NomineeAgentPasswordReset = '/nominee-agent/password-reset',
  NomineeCustomer = '/nominee-customer',
  NomineeInvestment = '/nominee/investments',
  NomineeInvestmentAttribution = '/nominee/investment-attribution',
  VerifyEmail = '/authentication/email-verification',
  ResetPassword = '/authentication/reset-password',
  UserProductReports = '/products/reports',
  WebSocket = '/ws',
}
